import Guardian from "./Guardian";
import common from "../../common";

export default class GuardianKnightFemale extends Guardian {
    constructor(golden = false) {
        super("guardian_knight_female", Guardian.TYPE_KNIGHT_FEMALE, golden);

        this.setIdleAnims(["idle1_knight"]);
        this.setAttackAnims(["attack_knight"]);
        this.setDamageAnims(["damage_knight"]);
        this.setDefeatAnims(["defeat_knight"]);
        this.setVictoryAnims(["victory_knight"]);
        this.setWeaponRevealAnims(["weapon_reveal_knight"]);

        this._attackSoundName = "sfx_guardian_sword_attack_00";
    }
}